import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "../../api";
import { AlertOctagon, Trash2, CheckCircle2, Clock } from "lucide-react";

const STATUS = {
  pendente: { label:"Pendente", color:"var(--danger)", bg:"rgba(179,58,58,0.08)" },
  em_analise: { label:"Em análise", color:"var(--sun-700)", bg:"rgba(199,154,58,0.1)" },
  respondida: { label:"Respondida", color:"var(--sun-600)", bg:"rgba(233,204,133,0.15)" },
  concluida: { label:"Concluída", color:"var(--success)", bg:"rgba(74,124,62,0.12)" },
};

export default function ComplaintsTab() {
  const [items, setItems] = useState([]);
  const [selected, setSelected] = useState(null);

  const load = () => { api.get("/admin/complaints").then(r=>setItems(r.data)).catch(()=>{}); };
  useEffect(load, []);

  const update = async (cid, status, response) => {
    await api.patch(`/admin/complaints/${cid}`, { status, admin_response: response });
    toast.success("Reclamação atualizada");
    setSelected(null); load();
  };
  const del = async (cid) => {
    if (!window.confirm("Excluir esta reclamação?")) return;
    await api.delete(`/admin/complaints/${cid}`); load();
  };

  return (
    <div className="grid lg:grid-cols-3 gap-6">
      <div className="lg:col-span-2 card-arya overflow-hidden">
        <div className="p-4 border-b border-[var(--line)] flex items-center gap-2">
          <AlertOctagon size={16} className="text-[color:var(--danger)]"/>
          <h3 className="font-serif text-xl">Reclamações recebidas</h3>
          <span className="ml-auto tag-sun">{items.length}</span>
        </div>
        {items.length === 0 ? (
          <div className="p-10 text-center text-[color:var(--ink-500)] text-sm">Nenhuma reclamação registrada.</div>
        ) : (
          <ul className="divide-y divide-[var(--line)]">
            {items.map(c => {
              const st = STATUS[c.status] || STATUS.pendente;
              return (
                <li key={c.complaint_id} className="p-4 flex flex-wrap gap-3 items-start" data-testid={`cmp-${c.complaint_id}`}>
                  <div className="flex-1 min-w-[220px]">
                    <div className="flex items-center gap-2">
                      <span className="tag-sun">{c.category}</span>
                      <span className="text-xs" style={{color:st.color, background:st.bg, padding:"2px 10px", borderRadius:999}}>{st.label}</span>
                    </div>
                    <p className="font-display font-semibold mt-1">{c.subject}</p>
                    <p className="text-xs text-[color:var(--ink-500)]">Contra: {c.partner_name} · por {c.client_name || "anônimo"} ({c.client_email || "-"})</p>
                    <p className="text-sm mt-2">{c.description}</p>
                    {(c.photos?.length || c.videos?.length) ? (
                      <div className="mt-2 flex flex-wrap gap-2 text-xs">
                        {c.photos?.map((u,i)=><a key={"p"+i} href={u} target="_blank" rel="noreferrer" className="text-[color:var(--sun-700)] underline">📷 foto {i+1}</a>)}
                        {c.videos?.map((u,i)=><a key={"v"+i} href={u} target="_blank" rel="noreferrer" className="text-[color:var(--sun-700)] underline">🎬 vídeo {i+1}</a>)}
                      </div>
                    ) : null}
                    {c.admin_response && <p className="mt-2 text-xs italic text-[color:var(--ink-500)]">Resposta: {c.admin_response}</p>}
                    <p className="text-[10px] text-[color:var(--ink-500)] mt-1">{new Date(c.created_at).toLocaleString("pt-BR")}</p>
                  </div>
                  <div className="flex flex-col gap-1">
                    <button onClick={()=>setSelected(c)} className="btn-ghost !py-1 !px-3 text-xs" data-testid={`respond-${c.complaint_id}`}>Responder</button>
                    <button onClick={()=>del(c.complaint_id)} className="p-1 text-[color:var(--danger)]"><Trash2 size={14}/></button>
                  </div>
                </li>
              );
            })}
          </ul>
        )}
      </div>

      <div className="card-arya p-6 h-fit">
        {selected ? (
          <>
            <h3 className="font-serif text-lg mb-3">Responder: {selected.subject}</h3>
            <select defaultValue={selected.status} id="st" className="w-full rounded-xl border border-[var(--line)] bg-white px-3 py-2 text-sm mb-2">
              <option value="pendente">Pendente</option>
              <option value="em_analise">Em análise</option>
              <option value="respondida">Respondida</option>
              <option value="concluida">Concluída</option>
            </select>
            <textarea rows="4" defaultValue={selected.admin_response||""} id="resp" placeholder="Resposta/anotação da equipe"
                      className="w-full rounded-xl border border-[var(--line)] bg-white px-3 py-2 text-sm mb-2"/>
            <div className="flex gap-2">
              <button onClick={()=>setSelected(null)} className="btn-ghost flex-1">Cancelar</button>
              <button onClick={()=>update(selected.complaint_id, document.getElementById("st").value, document.getElementById("resp").value)} className="btn-gold flex-1" data-testid="btn-save-cmp">Salvar</button>
            </div>
          </>
        ) : (
          <p className="text-sm text-[color:var(--ink-500)]">Selecione uma reclamação para responder.</p>
        )}
      </div>
    </div>
  );
}
